<template>
    <h1 id="abbreviations" class="print-title">ABBREVIATIONS USED IN THIS VOLUME</h1>
    <h2 class="print-title black-title small-title text-lowercase">
        List of Abbreviations of Stud Book codes and ISO Country codes
    </h2>

    <div class="abbreviations-table">
        <div class="abbreviations-header container-grid-3-left-2fr">
            <div class="abbreviations-col">Country</div>
            <div class="abbreviations-col">ISO CODE</div>
            <div class="abbreviations-col">STUD BOOK CODE</div>
        </div>
        <div
            class="container-grid-3-left-2fr"
            v-for="(item,index) in abbreviationsList"
            :key="index"
        >
            <div class="abbreviations-col">{{ item.name }}</div>
            <div class="abbreviations-col">{{ item.alpha2 }}</div>
            <div class="abbreviations-col">{{ item.alpha3 }}</div>
        </div>
    </div>

    <h2 class="print-title black-title small-title text-left">
        ABBREVIATIONS USED IN THIS VOLUME
    </h2>
    <div class="abbreviations-table">
        <div
            class="container-grid-2-right-2fr"
            v-for="(item,index) in abbreviationsUsedInVolume"
            :key="index"
        >
            <div class="abbreviations-col">{{ item.abbreviations }}</div>
            <div class="abbreviations-col">{{ item.explanation }}</div>
        </div>
    </div>

</template>

<script>
export default {
    name: "AbbreviationsList",
    props: {
        abbreviationsList: {
            type: [Array],
            required: true,
        },
        abbreviationsUsedInVolume: {
            type: [Array],
            required: true,
        },
    },
};
</script>
